import {isCacheResponseInfo} from '../../../srcCommon/services/offline/offlineResourcesCommon';
import {FetchSourcesEnum} from '../trace';
import {ResponseInfo} from './legacyPerformanceMiddleware';

const frontServerTimeHeader = 'x-front-time';
const frontTaskId = 'x-front-trace-task-id';

export type FetchInfos =
  | {
      source: FetchSourcesEnum.CACHE;
      contentUpdatedAt: number;
      fetchedAt: number;
    }
  | {
      source: FetchSourcesEnum.SERVER;
      serverTime: number | undefined;
      taskId: string | undefined;
      cacheMiss: boolean;
    };

export function fetchInfosFromResponse(info: ResponseInfo): FetchInfos {
  if (isCacheResponseInfo(info)) {
    return {
      source: FetchSourcesEnum.CACHE,
      contentUpdatedAt: info.contentUpdatedAt,
      fetchedAt: info.fetchedAt,
    };
  }

  const serverTime = Number(info.headers[frontServerTimeHeader]);
  const taskId = info.headers[frontTaskId];

  return {
    source: FetchSourcesEnum.SERVER,
    serverTime: Number.isFinite(serverTime) ? serverTime : undefined,
    taskId,
    cacheMiss: info.cacheMiss,
  };
}
